// OAuth callback errors (e.g. from Active Directory SSO) arrive as `error` and
// `error_description` query params on the redirect URL. AWS Amplify's OAuth
// handler strips these from the URL via `window.history.replaceState` while
// processing the failed callback, so we capture them synchronously at module
// load — before `Amplify.configure()` runs — and keep them available for the
// dedicated error page.

export interface OAuthError {
  error: string | null;
  errorDescription: string | null;
}

export const parseOAuthError = (search: string): OAuthError | null => {
  const params = new URLSearchParams(search);
  const error = params.get("error");
  const errorDescription = params.get("error_description");

  if (!error && !errorDescription) {
    return null;
  }

  return { error, errorDescription };
};

export const buildOAuthErrorSearch = (oauthError: OAuthError): string => {
  const params = new URLSearchParams();
  if (oauthError.error) {
    params.set("error", oauthError.error);
  }
  if (oauthError.errorDescription) {
    params.set("error_description", oauthError.errorDescription);
  }
  return params.toString();
};

// Captured at import time so the params survive Amplify clearing the URL.
// The destination (dedicated error page vs. "Network Access Pending") is decided
// by the provider in PageLayout.
let capturedError: OAuthError | null =
  typeof window !== "undefined" ? parseOAuthError(window.location.search) : null;

export const getOAuthError = (): OAuthError | null => capturedError;

export const clearOAuthError = (): void => {
  capturedError = null;
};
